<template>
  <div class="pa-8">
    <v-row>
      <v-col class="text-center">
        پلتفـرم آمـوزشی دُرَک
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field color="#8F9A80" v-if="loginMethod === 'password'" label="شماره تلفن / ایمیل"
                      v-model="credentials.username"
                      autocomplete="on"
                      aria-autocomplete="both"
        ></v-text-field>
        <v-text-field color="#8F9A80" v-else-if="loginMethod === 'otp'" label="شماره تلفن"
                      v-model="credentials.username"
                      autocomplete="on"
                      aria-autocomplete="both"
        ></v-text-field>
      </v-col>
      <v-col cols="12" v-if="(loginMethod ==='password' ||  otpStep===2)">
        <v-text-field color="#8F9A80" v-if="loginMethod === 'password'" label="رمــز ورود"
                      v-model="credentials.password" type="password"></v-text-field>
        <v-row v-if="loginMethod === 'otp' && otpStep === 2">
          <v-col cols="12" class="text-center">
            <div class="otp-inputs" style="direction: ltr!important;">
              <input
                  style="direction: ltr!important;"
                  v-for="(digit, index) in otp"
                  :key="index"
                  class="otp-box"
                  type="text"
                  inputmode="numeric"
                  maxlength="1"
                  v-model="otp[index]"
                  :ref="'otp-' + index"
                  @input="onOtpInput($event, index)"
                  @keydown.backspace="onOtpBackspace($event, index)"
              />
            </div>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn rounded color="#8F9A80" @click="login()">
                  <span style="font-size: 15px!important;" v-if="loginMethod === 'password' || otpStep ===2">
                  وارد شوید
                  </span>
          <span style="font-size: 15px!important;" v-else>
                  ارسال کد
                  </span>
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn color="#8F9A80" v-if="loginMethod === 'password'" @click="loginMethod = 'otp'">
          <span style="font-size: 15px!important;">
          رمـــز یـکـبـار مـصـرف
          </span>
        </v-btn>
        <br>
        <div class="mt-16" style="margin-top: 200px!important;">
          حــســاب کــاربــری نـداریـد؟

        </div>
        <v-btn class="mt-1" color="#8F9A80" @click="$router.push('/register')">
            <span style="font-size: 15px">
            ثبت نام
            </span>
        </v-btn>
      </v-col>

    </v-row>
    <br>


    <v-dialog v-model="deleteAllDevices" max-width="90vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            فقط با ۳ دستگاه می توانید به صورت هم زمان وارد شوید.
            برای ورود، از دستگاه های قبلی خارج شوید.
          </v-col>

          <v-col cols="12">

          </v-col>

          <v-col cols="12">
            <v-btn style="letter-spacing: normal" color="error" @click="exitAllDevices()">خروج از تمام دستگاه ها</v-btn>
          </v-col>
        </v-row>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
// import DragAndDropDesktop from "@/components/Components/Desktop/UploadFile/DragAndDropDesktop";

export default {
  name: "LoginRegisterMobile",
  // components: {DragAndDropDesktop},
  data() {
    return {
      deleteAllDevices: false,
      otp: Array(5).fill(""),  // Array to hold the 5 OTP digits
      showPassword: false,
      currentImage: require('@/assets/new/login1.png'), // Default image
      loginMethod: 'password',
      hoverTimeouts: [], // To store timeouts for clearing them on 'mouseleave'
      loading: true,
      otpStep: 1,
      profileImageDialog: false,
      loginType: 'email',
      waitForOtp: true,
      loginImagePath: '@/assets/new/login1.png',
      student: {
        name: null,
        email: null,
        birth_date: null,
        gender: null,
        mobile: null,
        password: null,
        password_confirmation: null,
        profile_image: null,
        state_id: null,
        city_id: null,
        school_id: null,
      },
      credentials: {
        username: null,
        password: null,
        code: null
      },
      states: [],
      cities: [],
      schools: []
    }
  },
  mounted() {
    this.getStates()
    this.getSchools()
    this.loading = false
  },
  methods: {
    exitAllDevices(){
      window.axios.post('/student/auth/delete-devices',{
        username : this.credentials.username ?? this.credentials.email ?? this.credentials.phone,
      }).then((res=>{
        console.log(res)
        location.reload();
      }))
    },
    onOtpInput(event, index) {
      const value = event.target.value;
      if (value.length === 1 && value.match(/^[0-9]$/)) {
        if (index < this.otp.length - 1) {
          // Move to the next input box
          this.$refs[`otp-${index + 1}`][0].focus();
        }
      } else {
        // Invalid input, clear it
        this.$set(this.otp, index, "");
      }
    },
    onOtpBackspace(event, index) {
      if (!this.otp[index] && index > 0) {
        // Move to the previous input box on backspace
        this.$refs[`otp-${index - 1}`][0].focus();
      }
    },
    onMouseOver() {
      // Clear existing hover timeouts, if any
      this.clearHoverTimeouts();

      // First transition: after 1 second, change to login2.png
      const firstTimeout = setTimeout(() => {
        this.currentImage = require('@/assets/new/login2.png');
      }, 1000); // 1 second delay

      // Second transition: after another 1 second, change to login3.png
      const secondTimeout = setTimeout(() => {
        this.currentImage = require('@/assets/new/login3.png');
      }, 2000); // 2 seconds delay (cumulative)

      // Store timeouts for clearing on mouse leave
      this.hoverTimeouts.push(firstTimeout, secondTimeout);
    },
    onMouseLeave() {
      // Clear all pending hover transitions
      this.clearHoverTimeouts();

      // Reset the image to the default (login1.png)
      this.currentImage = require('@/assets/new/login1.png');
    },
    clearHoverTimeouts() {
      // Loops through and clears active timeouts
      this.hoverTimeouts.forEach(timeout => clearTimeout(timeout));
      this.hoverTimeouts = []; // Reset the timeout tracker
    },

    getSchools() {
      window.axios.get('/school/index').then((res) => {
        this.schools = res.data.data
      })
    },
    login() {
      if (this.loginMethod === 'password' && this.otpStep === 1) {
        window.axios.post('/student/auth/login', {
          user_name: this.credentials.username,
          password: this.credentials.password
        }).then((res) => {
          this.$store.state.user = res.data.data.user
          this.$store.state.auth = true
          this.$cookies.set('token', 'Bearer ' + res.data.data.token)
          this.$router.push('/dashboard').then(() => {
            location.reload();
          });
        }).catch((err) => {
          if (err.response.status === 429) {
            this.deleteAllDevices = true
          } else if (err.response.status === 422) {
            this.showValidationErrors(err, '#F1416C')
          } else if (err.response.status === 404) {
            this.openSnackbar(err.response.data.message, '#F1416C')
          } else if (err.response.status === 400) {
            this.openSnackbar(err.response.data.message, '#F1416C')
          } else if (err.response.status === 403) {
            this.openSnackbar(err.response.data.message, '#F1416C')
          }
        })
      } else if (this.loginMethod === 'otp' && this.otpStep === 1) {
        window.axios.post('/student/auth/otp/get', {
          mobile: this.credentials.username,
        }).then(() => {
          this.otpStep = 2
        }).catch((err) => {
          if (err.response.status === 429) {
            this.deleteAllDevices = true
          } else if (err.response.status === 422) {
            this.showValidationErrors(err, '#F1416C')
          } else {
            this.openSnackbar(err.response.data.message, '#F1416C')
          }
        })
      } else {
        const otpCode = this.otp.join(""); // Combine OTP digits
        if (otpCode.length === 5) {
          console.log("OTP Submitted:", otpCode);
          window.axios.post('/student/auth/otp/verify', {
            mobile: this.credentials.username,
            code: otpCode
          }).then((res) => {
            this.$store.state.user = res.data.data.user
            this.$store.state.auth = true
            this.$cookies.set('token', 'Bearer ' + res.data.data.token)
            this.$router.push('/dashboard').then(() => {
              location.reload();
            });
          }).catch((err) => {
            if (err.response.status === 429) {
              this.deleteAllDevices = true
            } else if (err.response.status === 422) {
              this.showValidationErrors(err, '#F1416C')
            } else if (err.response.status === 404) {
              this.openSnackbar(err.response.data.message, '#F1416C')
            } else if (err.response.status === 400) {
              this.openSnackbar(err.response.data.message, '#F1416C')
            }
          })
        } else {
          this.openSnackbar('کد تایید کامل نیست.', '#F1416C')
        }
      }
    },
    loginWithMobile() {
      window.axios.post('/student/auth/otp/verify', {
        mobile: this.credentials.phone,
        code: this.credentials.code
      }).then((res) => {
        this.$store.state.user = res.data.data.user
        this.$store.state.auth = true
        this.$cookies.set('token', 'Bearer ' + res.data.data.token)
        this.$router.go(0)
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 404) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    getStates() {
      window.axios.get('/system/state/index').then((res) => {
        this.states = res.data.data
      })
    },
    getCities() {
      window.axios.get('/system/city/index?state_id=' + this.student.state_id).then((res) => {
        this.cities = res.data.data
      })
    },
    sendOtp() {
      window.axios.post('/student/auth/otp/get', {
        mobile: this.credentials.phone
      }).then(() => {
        this.otpStep = 2
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    register() {
      window.axios.post('/student/register', this.student).then(() => {
        this.openSnackbar('ثبت نام شما با موفقیت انجام شد.', '#1ab69d')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    loginWithEmail() {
      window.axios.post('student/auth/email/login', {
        email: this.credentials.email,
        password: this.credentials.password
      }).then((res) => {
        this.$store.state.user = res.data.data.user
        this.$store.state.auth = true
        this.$cookies.set('token', 'Bearer ' + res.data.data.token)
        this.$router.go(0)
      }).catch((err) => {
        if (err.response.status === 429) {
          this.deleteAllDevices = true
        } else if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400 || err.response.status === 404) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
  }
}
</script>

<style scoped>

.otp-container {
  position: absolute !important;
  top: 460px !important;
  right: 106px !important;
}

.otp-container-english {
  position: absolute !important;
  top: 460px !important;
  left: 106px !important;
}

.otp-title {
  font-size: 24px;
  color: #536391;
  margin-bottom: 20px;
}

.otp-inputs {
  display: flex;
  gap: 16px;
}

.otp-box {
  width: 55px !important;
  height: 32px !important;
  text-align: center;
  font-size: 20px;
  border-radius: 20px;
  transition: border-color 0.3s;
  border-color: #8F9A80 !important;
  border-style: solid !important;
  border-width: 0.5px;
}

.otp-box:focus {
  outline: none;
  border-color: #8F9A80;
}

.submit-otp-button {
  margin-top: 20px;
  background-color: #8F9A80;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
}

.submit-otp-button:hover {
  background-color: #F7A725;
  transform: scale(1.05);
}


.no-background {
  background-color: unset !important;;
}

.toggle-password {
  position: absolute;
  top: 50%;
  left: 10px; /* Adjusted for RTL to place it on the start of input */
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px; /* Adjust size as needed for better visibility */
  color: #ccc; /* Optionally, make the icon's color light */
}

.toggle-password:hover {
  color: #000; /* Darker color on hover for better interaction feedback */
}

.dorak-login-logo {
  background-color: #8f9a80 !important;
  top: 204px !important;
  position: absolute;
  right: 95px !important;
}

.top-circle {
  position: absolute;
  top: 0px !important;
  right: 37px !important;
  background-color: #8f9a80 !important;
}

.bottom-circle-persian {
  z-index: 1 !important;
  position: absolute;
  left: 0px !important;
  top: 172px !important;
  background-color: #8f9a80 !important;
}

.left-circle-persian {
  position: absolute;
  bottom: 0px !important;
  right: 0px !important;
  background-color: #8f9a80 !important;
}

.bottom-circle-english {
  z-index: 1 !important;
  position: absolute;
  right: 0px !important;
  top: 172px !important;
  background-color: #8f9a80 !important;
  transform: rotate(180deg) !important; /* Rotates when the class is applied */
}

.left-circle-english {
  position: absolute;
  bottom: 0px !important;
  left: 0px !important;
  background-color: #8f9a80 !important;
  transform: rotateY(180deg) !important; /* Rotates when the class is applied */
}

.main-container-login {
  width: 1692px;
  height: 887px;
  background-color: #f5f3ed !important;
  border-radius: 30px !important;

  /* Centering Configuration */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}


.title-login {
  background-color: #f5f3ed !important;
  color: #8F9A80 !important;
  font-size: 43px !important;
  position: absolute !important;
  top: 58px !important;
  right: 86px !important;
}

.title-login-english {
  background-color: #f5f3ed !important;
  color: #536391 !important;
  font-size: 50px !important;
  font-weight: 800;
  position: absolute !important;
  top: 58px !important;
  left: 86px !important;
}

.sub-title-login-english {
  direction: ltr !important;
  background-color: #f5f3ed !important;
  color: #8F9A80 !important;
  font-size: 50px !important;
  position: absolute !important;
  top: 141px !important;
  left: 86px !important;
}

.dorrak-logo-login {
  position: absolute !important;
  top: 131px !important;
  right: 87px !important;
  background-color: #f5f3ed !important;
}

.image-container-login-persian {
  width: 629px !important;
  height: 100% !important;
  position: absolute !important;
  left: 0;
  background-color: #8f9a80 !important;
  border-radius: 30px 0 0 30px !important;
}

.image-container-login-english {
  width: 629px !important;
  height: 100% !important;
  position: absolute !important;
  right: 0;
  background-color: #8f9a80 !important;
  border-radius: 0 30px 30px 0 !important;
  z-index: 100 !important;
}

.custom-input {
  background-color: #FFFFFF !important;
  border-radius: 30px !important;
  width: 768px !important;
  height: 66px !important;
  padding-right: 20px !important;
  font-size: 30px !important;
}

.label-phone {
  font-size: 30px !important;
  color: #536391;
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 254px !important;
  right: 106px !important;
}

.username-input {
  font-size: 30px !important;
  color: #536391;
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 310px !important;
  right: 86px !important;
}

.label-password {
  font-size: 30px !important;
  color: #536391;
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 402px !important;
  right: 106px !important;
}

.password-input {
  font-size: 30px !important;
  color: #536391;
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 458px !important;
  right: 86px !important;
}


.label-phone-english {
  font-size: 30px !important;
  color: #536391;
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 260px !important;
  left: 106px !important;
}

.username-input-english {
  font-size: 30px !important;
  color: #536391;
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 308px !important;
  left: 86px !important;
}

.label-password-english {
  font-size: 30px !important;
  color: #536391;
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 406px !important;
  LEFT: 106px !important;
}

.password-input-english {
  font-size: 30px !important;
  color: #536391;
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 456px !important;
  left: 86px !important;
}

.login-button-container {
  font-size: 30px !important;
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 562px !important;
  right: 86px !important;
}

.login-button-container-english {
  font-size: 30px !important;
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 562px !important;
  left: 86px !important;
}

.custom-buttons-container {
  font-size: 30px !important;
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 735px !important;
  right: 86px !important;
}

.custom-buttons-container-english {
  font-size: 21px !important;
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 735px !important;
  left: 86px !important;
}

.custom-button {
  background-color: #8F9A80 !important;
  border-radius: 40px !important;
}

.custom-button-2 {
  color: #8F9A80 !important;
  background-color: #f5f3ed !important;
  border-radius: 40px !important;
  border-style: solid;
  border-color: #8F9A80 !important;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 25px !important;
  padding-left: 25px !important;
}

.custom-button-2:hover {
  border-color: #F7A725 !important;
}

.custom-button:hover {
  background-color: #F7A725 !important;
}

.custom-button-3:hover {
  background-color: #F7A725 !important;
}

>>> .v-btn__content {
  letter-spacing: normal !important;
  color: #fdfdfd !important;
  background-color: unset !important;
  font-size: 30px !important;
  font-weight: 800 !important;
}

>>> .v-btn__content:hover {
  background-color: #F7A725 !important;
}

.text-subtitle-custom {
  position: absolute;
  right: 86px !important;
  top: 809px !important;
}

.text-subtitle-custom-english {
  position: absolute;
  left: 86px !important;
  top: 809px !important;
}

.custom-sub-text {
  font-size: 30px !important;
  color: #8F9A80;
  background-color: #f5f3ed !important;
}

.signup-button-container {
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 809px !important;
  right: 502px !important;
}

.signup-button-container-english {
  background-color: #f5f3ed !important;
  position: absolute !important;
  top: 809px !important;
  left: 480px !important;
}

.custom-button-3 {
  color: #F5F3ED !important;
  background-color: #8F9A80 !important;
  border-radius: 50px !important;
  font-size: 22px !important;
  padding: 5px 25px !important;
}

.login-shape {
  top: 15.8vh;
  right: 7.8vw;
  position: absolute !important;
  z-index: 2;
}

.register-shape {
  top: 17.8vh;
  left: 45%;
  position: absolute !important;
}

.custom-margin-login-register {
  margin-top: 10vh;
  margin-left: 10vw !important;
  margin-right: 10vw !important;
}
</style>